import { Row, Select, Spin, Tooltip } from "antd";
import "./ChannelSelector.css";

import {
  useDiscordChannelsContext,
  useSlackChannelsContext,
} from "../../ChannelContext/ChannelContext";
import { useNavigate } from "react-router-dom";
import { RedoOutlined } from "@ant-design/icons";
import { getSupaClient } from "apps/dots-frontend/src/lib/supabase";
import { useQueryClient } from "react-query";
import RefreshButton from "../../RefreshButton/RefreshButton";
import useRefreshChannelsAndRoles from "../../TriggerEditor/useRefreshChannelsAndRoles";

const { Option } = Select;

function ChannelSelector(props) {
  const {
    platform,
    showTitle = true,
    onlyCustomChannels = false,
    customStyles,
    customChannels,
    defaultOption,
    errorOptionString = "Select",
    readOnly = false,
    showRefreshButton = false, // it frefreshes discord channels and roles when clicked
  } = props;

  const {
    loading: loadingDiscord,
    allChannels: channelsDiscord,
    setChannels: setChannelsDiscord,
    selectedChannel: selectedChannelDiscord,
    setSelectedChannel: setSelectedChannelDiscord,
  } = useDiscordChannelsContext();

  const {
    loading: loadingSlack,
    allChannels: channelsSlack,
    setChannels: setChannelsSlack,
    selectedChannel: selectedChannelSlack,
    setSelectedChannel: setSelectedChannelSlack,
  } = useSlackChannelsContext();

  const { isRefreshLoading, refreshSuccess, refresh, resetRefreshState } =
    useRefreshChannelsAndRoles();

  const navigate = useNavigate();
  const isDiscord = platform === "discord";
  const onSelectedChannelChange = (value) => {
    let channel;
    if (isDiscord) {
      props.handleChannelSelection
        ? props.handleChannelSelection(value)
        : navigate(`/insights?channel=${value}`);
    } else {
      channel = channelsSlack.find((ch) => ch.slack_id === value);
      setSelectedChannelSlack(channel);
      props.handleChannelSelection(channel);
    }
  };

  let placeholder;
  if (isDiscord) {
    placeholder = selectedChannelDiscord
      ? selectedChannelDiscord.name
      : "Select a channel";
  } else {
    placeholder = selectedChannelSlack
      ? selectedChannelSlack.name
      : "Select a channel";
  }

  return (
    <Spin spinning={isDiscord ? loadingDiscord : loadingSlack}>
      <Row>
        {showTitle && <p className="pt-1.5">Select a channel: </p>}
        <Select
          disabled={readOnly}
          showSearch
          placeholder={placeholder}
          onChange={onSelectedChannelChange}
          style={!customStyles ? { width: 200, marginLeft: 10 } : customStyles}
          filterOption={(input, option) => {
            return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
          defaultValue={defaultOption || null}
          dropdownRender={(menu) => (
            <div>
              {showRefreshButton && (
                <div className="flex items-center justify-end px-1 py-1">
                  <RefreshButton
                    refresh={refresh}
                    resetRefreshState={resetRefreshState}
                    isLoading={isRefreshLoading}
                    success={refreshSuccess}
                    hintText="Can't find a channel? click here to refresh"
                  />
                </div>
              )}
              {menu}
            </div>
          )}
        >
          {[
            // if onlyCustomChannels = true, all other existing channels will not be displayed
            ...(onlyCustomChannels
              ? []
              : isDiscord
              ? channelsDiscord
              : channelsSlack),
            ...(customChannels ? customChannels : []),
          ].map((channel, index) => (
            <Option
              key={
                channel[`${platform}_id`]
                  ? channel[`${platform}_id`]
                  : channel.id
              }
              value={
                channel[`${platform}_id`]
                  ? channel[`${platform}_id`]
                  : channel.id
              }
              name={channel.name}
              id={index}
            >
              {channel.name}
            </Option>
          ))}
          <Option
            key={-1}
            value={-1}
            name=""
            disabled
            style={{ display: "none" }}
          >
            {errorOptionString}
          </Option>
        </Select>
      </Row>
    </Spin>
  );
}

export default ChannelSelector;
